exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1jGnhqQlWfiTcmlchuhSCc{font-size:12px;font-weight:400}html[dir] ._1jGnhqQlWfiTcmlchuhSCc{padding:0}.fAMqoYf2qN3z2YUuO4OIV{height:24px}html[dir] .fAMqoYf2qN3z2YUuO4OIV{margin-top:8px}._2xpZLPwjGyHJurng4wFo5W{height:24px}html[dir] ._2xpZLPwjGyHJurng4wFo5W{margin-top:8px}html[dir=ltr] ._2xpZLPwjGyHJurng4wFo5W{margin-right:8px}html[dir=rtl] ._2xpZLPwjGyHJurng4wFo5W{margin-left:8px}", ""]);
// Exports
exports.locals = {
	"errorLabel": "_1jGnhqQlWfiTcmlchuhSCc",
	"reconnectButton": "fAMqoYf2qN3z2YUuO4OIV",
	"removeButton": "_2xpZLPwjGyHJurng4wFo5W"
};